<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/fDRSdB/tc-custom/9781423655381.jpg?1737555399436" alt="This image is the cover for the book Naturally, Delicious: Desserts"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Naturally, Delicious: Desserts
      </h1>
      <p class="bookDescription body article font2">
        <b>An “accessible collection of health-conscious desserts” from the sustainable-lifestyle expert, NBC host, and author of <i>Naturally, Delicious</i> (<i>Publishers Weekly</i>).</b><br/>  <br/> The Editor-in-Chief of <i>Naturally, Danny Seo</i> presents an exciting cookbook packed with approximately one hundred dessert and sweet treat recipes from the magazine that are organic, creative, and delicious.<br/>  <br/> Packed with real nutritional value, these sweets don’t skimp on taste: they are just as rich, just as creamy, just as enticing, just as sweet. Danny Seo proves once again that your daily indulgences can be healthy, eco-friendly, time efficient, sustainable, and, with these stellar desserts on display, more delicious than ever before.<br/>  <br/> There are vegan desserts, fruit-packed treats, and superfood-charged snacks made with healthy ingredients like dark chocolate, whole grains, nuts and nut butters, seeds, fruits, and even vegetables. With recipes like Parsnip Brown Butter Sugar Cookies; Root Vegetable Funfetti Cookies; Paleo Sweet Potato Monkey Bread; Crunchy-Good Cardamom Granola; Miso Caramel Popcorn; Oversized Blue Spirulina Marshmallows; Orange Quinoa Olive Oil Cake; and Winter Matcha Peppermint Patties, indulgent eating doesn’t mean you have to skip out on health.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Danny Seo
      </h2>
      
      <p class="authorDescription body article"><B>Danny Seo</B> is the editor-in-chief of <I>Naturally, Danny Seo</I>, a national print magazine that celebrates the idea that style and sustainability don&#39;t need to be mutually exclusive from each other. <I>Naturally, Delicious Desserts </I>is his 11th book and his second cookbook, following the hit success <I>Naturally, Delicious</I>. Danny was the host of the Emmy Award-winning TV show <I>Naturally, Danny Seo</I> on NBC, which brought all of the ideas for cooking, home decorating, beauty, wellness, and travel to life that you see in the pages of his magazine. His line of eco-friendly products is sold in stores across the United States, Canada, and Europe, including retailers like TJ Maxx, Marshalls, and HomeGoods. He lives in Bucks County, Pennsylvania.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Gibbs Smith
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?cabbad5a